(function () {
  'use strict';

  var internalHosts = null;

  function normalizeHost(host) {
    return String(host || '')
      .toLowerCase()
      .replace(/^www\./, '');
  }

  function buildInternalHosts() {
    if (internalHosts) return internalHosts;

    internalHosts = new Set();
    internalHosts.add(normalizeHost(window.location.hostname));

    if (window.Shopify && Shopify.shop) {
      internalHosts.add(normalizeHost(Shopify.shop));
    }

    var shopMeta = document.querySelector('meta[name="shopify-digital-wallet"]');
    if (shopMeta && shopMeta.content) {
      try {
        var meta = JSON.parse(shopMeta.content);
        if (meta.shopId) {
          /* no-op: host comes from Shopify.shop when available */
        }
      } catch (e) {
        /* ignore */
      }
    }

    document.querySelectorAll('[data-shop-domain]').forEach(function (el) {
      internalHosts.add(normalizeHost(el.getAttribute('data-shop-domain')));
    });

    return internalHosts;
  }

  function isInternalNavigationLink(link) {
    if (!link || link.tagName !== 'A') return false;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return true;
    if (/^(mailto:|tel:|sms:|javascript:)/i.test(href)) return true;

    try {
      var url = new URL(link.href, window.location.origin);
      if (url.origin === window.location.origin) return true;
      return buildInternalHosts().has(normalizeHost(url.hostname));
    } catch (e) {
      return true;
    }
  }

  function fixLinks(root) {
    var scope = root || document;
    scope.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      if (!isInternalNavigationLink(link)) return;

      link.removeAttribute('target');
      link.removeAttribute('aria-describedby');

      var rel = link.getAttribute('rel') || '';
      rel = rel
        .split(/\s+/)
        .filter(function (token) {
          return token && token !== 'noopener' && token !== 'noreferrer';
        })
        .join(' ');
      if (rel) link.setAttribute('rel', rel);
      else link.removeAttribute('rel');
    });
  }

  function init() {
    fixLinks(document);
    window.addEventListener('load', function () {
      fixLinks(document);
    });
  }

  window.TcbLinkBehavior = {
    fixLinks: fixLinks,
    isInternalNavigationLink: isInternalNavigationLink
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    fixLinks(event.target);
  });
})();
